module.exports = devowlWp_realProductManagerWpClient;